// extracted by mini-css-extract-plugin
export var peopleCard = "PeopleCard-module--peopleCard--14VJ-";
export var headshot = "PeopleCard-module--headshot--33iME";
export var headshotImg = "PeopleCard-module--headshot-img--dF5CW";
export var leaderLabel = "PeopleCard-module--leader-label--1Sp37";
export var heading = "PeopleCard-module--heading--1GX5M";
export var details = "PeopleCard-module--details--22M7w";
export var cta = "PeopleCard-module--cta--1-0Vm";
export var phone = "PeopleCard-module--phone--kUOyl";